import { createSelector } from 'reselect';

import type { AppState } from 'types/app';
import type { Benefits } from 'types/rewards';

export const selectRewards = (state: AppState) => state.rewards || {};

export const selectRewardsInfo = createSelector(selectRewards, rewards => rewards?.rewardsInfo || {});

export const selectRewardsDetermined = (state: AppState) => selectRewards(state)?.isRewardsDetermined;

export const selectIsRewardsInfoLoaded = (state: AppState) => selectRewards(state)?.isRewardsInfoLoaded;

export const selectIsVip = (state: AppState) => selectRewardsInfo(state).isVipOrConsented;

export const selectRewardsBenefits = (state: AppState): Partial<Benefits> => selectRewardsInfo(state).benefits || {};

export const selectIsEnrolled = (state: AppState) => selectRewardsInfo(state)?.enrolled;

export const selectSharedRewards = (state: AppState) => state.sharedRewards;

export const selectIsEnrollingRewards = createSelector(selectSharedRewards, state => state.isEnrollingRewards);

export const selectIsVipOrEnrolling = createSelector([selectIsVip, selectIsEnrollingRewards], (isVip, isEnrolling) => Boolean(isVip || isEnrolling));
